import React from "react";
import { BetSelections } from "@tvg/design-system";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import { ExoticBetSelectionsProps } from "../types";

const ExoticBetSelections = ({
  selectionsList,
  columnCount,
  betTypeNames
}: ExoticBetSelectionsProps) => (
  <>
    {Array(columnCount)
      .fill(null, 0)
      .map((_item: string, index: number) => (
        <BetSelections
          key={`exotic-bet-selections-${index.toString()}`}
          qaLabel="bet-slip-selections"
          type={betTypeNames[index] as WagerTypeCodesEnum}
          selections={selectionsList[index as number]}
        />
      ))}
  </>
);

export default ExoticBetSelections;
